import { render, staticRenderFns } from "./ClipPaperIcon.vue?vue&type=template&id=bb1c6e6a"
import script from "./ClipPaperIcon.vue?vue&type=script&lang=js"
export * from "./ClipPaperIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports